import React from "react";

import { SovosToolbarGroup, SovosToolbarActions } from "mosaic-react";
import { DefaultToolbar, DataGridTabs } from "colbi_web_ui/lib/components";
import DatagridExportButton from "../DatagridExportButton/DatagridExportButton";

const GenericViewsToolbar = ({ defaultToolbarProps, toolbarProps }) => {
    const { data, exportableArray, tabsProps, showCsvOption } = toolbarProps;
    return (
        <SovosToolbarGroup sx={{ width: "100%" }}>
            <SovosToolbarGroup
                sx={{ flex: "1 1 auto", justifyContent: "flex-start", paddingRight: "10px" }}
            >
                <DataGridTabs {...tabsProps} />
            </SovosToolbarGroup>
            <SovosToolbarGroup>
                <SovosToolbarActions>
                    <DatagridExportButton data={data} exportableArray={exportableArray} showCsvOption={showCsvOption} />
                    <DefaultToolbar {...defaultToolbarProps} />
                </SovosToolbarActions>
            </SovosToolbarGroup>
        </SovosToolbarGroup>
    );
};

export default GenericViewsToolbar;
